const r = "_content_4l9nr_1", o = "_scaleToAnchor_4l9nr_14", t = "_isModalPopover_4l9nr_56", a = "_arrow_4l9nr_34", n = "_viewport_4l9nr_69", _ = "_additionalItems_4l9nr_73", e = {
  content: r,
  scaleToAnchor: o,
  "arrow--start": "_arrow--start_4l9nr_34",
  "arrow--end": "_arrow--end_4l9nr_38",
  "arrow--vertical--start": "_arrow--vertical--start_4l9nr_43",
  "arrow--vertical--center": "_arrow--vertical--center_4l9nr_47",
  "arrow--vertical--end": "_arrow--vertical--end_4l9nr_51",
  isModalPopover: t,
  arrow: a,
  viewport: n,
  additionalItems: _
};
export {
  _ as additionalItems,
  a as arrow,
  r as content,
  e as default,
  t as isModalPopover,
  o as scaleToAnchor,
  n as viewport
};
//# sourceMappingURL=index.es763.js.map
